import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {pairwise, startWith} from "rxjs/operators";
import {CoreService} from "../../../../../services/core/core.service";

@Component({
    selector: 'app-bid-final-preview',
    templateUrl: './bid-final-preview.component.html',
    styleUrls: ['./bid-final-preview.component.scss'],
    standalone: false
})
export class BidFinalPreviewComponent implements OnInit {

  @Input() isEdit: boolean = false;
  @Input() model: any = {};
  @Input() form: any = {};
  @Output() callback = new EventEmitter<any>(true);

  public bidDetail:any = {};
  public scopesStage:any = {};
  public assignment:any = {};
  public jobsiteAddressDetail:any = {};


  constructor(
    public coreService: CoreService
  ) { }

  ngOnInit(): void {

    this.model = this.model?.model;
    this.form.get('step01').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.bidDetail = next?.bidDetail;
      });

    this.form.get('step02').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.scopesStage = next?.scopesStage;
      });

    this.form.get('step03').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.assignment = next?.assignment;
      });

    this.form.get('step04').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.jobsiteAddressDetail = next?.jobsiteAddressDetail;
      });
  }

}
